import initialState from 'store/hoReducers/fileSystem/initialState';

export default {
  ...initialState,
  exportAll: {
    error: '',
    isLoading: false,
  },
  addFolder: {
    isLoading: false,
    error: '',
  },
  editFolder: {
    isLoading: false,
    error: '',
  },
  editFile: {
    isLoading: false,
    error: '',
  },
  deleteFolder: {
    isLoading: false,
    error: '',
  },
  deleteFile: {
    isLoading: false,
    error: '',
  },
  exportFileOrFolder: {
    isLoading: false,
    error: '',
  },
  syncFiles: {
    isLoading: false,
    error: '',
  },
  upload: {
    isLoading: false,
    error: '',
    conflicts: null,
  },
};
